import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_insure-biz-group/artifacts/be293ixx_FullLogo_Transparent.png";

/**
 * Key Legacy Protection brand mark — transparent PNG (gold crest + wordmark).
 * Variants:
 *  - "emblem": shows just the top crest portion (crown + wreath + K) by
 *    cropping out the wordmark — for compact spots next to a text wordmark.
 *  - "full":   shows the complete logo including wordmark — for footer,
 *    splash, and other spaces with room.
 */
export default function BrandMark({
  size = 40,
  variant = "emblem",
  className = "",
}) {
  if (variant === "full") {
    return (
      <img
        src={LOGO_URL}
        alt="Key Legacy Protection"
        className={`block ${className}`}
        style={{ height: size, width: "auto" }}
      />
    );
  }

  // Emblem variant — crop the wordmark out by scaling the image larger than
  // its square container and anchoring it to the top. Transparent PNG so no
  // background needed.
  return (
    <span
      className={`relative inline-block overflow-hidden ${className}`}
      style={{ height: size, width: size }}
      aria-label="Key Legacy Protection mark"
      role="img"
    >
      <img
        src={LOGO_URL}
        alt=""
        aria-hidden="true"
        className="absolute left-1/2 -translate-x-1/2"
        style={{
          height: size * 1.9,
          width: "auto",
          top: -size * 0.22,
          maxWidth: "none",
        }}
      />
    </span>
  );
}
